import TagSliderMixin from '@/components/mixins/tag-slider-mixin'
import EventBus from '@/components/mixins/event-bus-mixin'
import OnEnterMixin from '@/components/mixins/onenter-mixin'
import _ from 'lodash'
import CONST from '@/globals/constants'
import { mapActions, mapState } from 'pinia'
import { popIdsStore } from '@/pinia/stores/popIdsStore'
import { selectionStore } from '../../../pinia/stores/selectionStore'
import { COMPONENT_KEY } from '../../../pinia/stores/storeUtils'
import Draggable from 'vuedraggable'

export default {
  name: 'popIdentifierSlider',
  inject: [
    '$currentUser',
    '$utils',
    '$dataStore',
    '$apiError',
    '$filtersRepository'
  ],
  components: {
    Draggable
  },
  props: {
    accessorComponentProp: {
      type: String,
      default () { return 'mediaFiles' }
    },
    refreshPopIdsSliderProp: {
      type: Object,
      default () { return { ref: null, refresh: false } }
    },
    popIdSelectionRequestProp: {
      type: Object,
      default () { return { ref: null, popIds: [], default: false } }
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    refreshPopIdsSliderProp (newVal) {
      if (newVal && (newVal.ref && newVal.refresh)) {
        this.setPopIdsData(this.popIds)
      }
    },
    popIdSelectionRequestProp (newVal) {
      this.handlePopIdSelectionRequest({ newVal })
    },
    accessorComponentProp (newVal) {
      this.accessorComponent = newVal
      this.setDefaultData()
    },
    popIds: {
      handler () {
        this.$nextTick(_ => {
          this.setElementDataHeightAttributeValue()
        })
      },
      deep: true
    },
    expanded () {
      this.$nextTick(_ => {
        this.setElementDataHeightAttributeValue()
      })
    }
  },
  mixins: [TagSliderMixin, OnEnterMixin],
  data () {
    return {
      CONST,
      componentName: 'popIdSlider',
      elementHeight: 0,
      showPopIdsSlider: this.$currentUser.hasFeatureProofOfPlayExtended(),
      dropSlide: true,
      isComponentUseInFilesPage: false,
      isComponentUseInLedPage: false,
      isComponentUseInVideowallPage: false,
      isComponentUseInAlertPage: false,
      isComponentUseInSchedulePageAllPlayers: false,
      isComponentUseInPlayersPage: false,
      isComponentUseInMediaPicker: false,
      accessorComponentName: {
        mediaFiles: 'mediaFiles',
        mediaAlert: 'mediaAlert',
        schedulePagePlayers: 'schedulePagePlayers',
        playerPage: 'playerPage',
        ledPage: 'ledPage',
        mediaListInModal: 'mediaListInModal'
      },
      accessorComponent: this.accessorComponentProp,
      editPopIds: [],
      editPopIdValue: '',
      popIds: [],
      isEditPopIdActionEnabled: false,
      enableEditPopId: true,
      previousKeyPressedInPopIdSelection: null,
      multipleTagSelection: true,
      showDeleteAction: false,
      lockedPopIdExpandAction: false,
      defaultAllTag: {
        value: CONST.ALL_TAG_VALUE,
        name: CONST.ALL_TAG_VALUE,
        label: this.$t('label.all'),
        backgroundColor: '#fff',
        leds: []
      },

      selectedDropzoneId: null
    }
  },
  computed: {
    sortDraggableOptions () {
      return { animation: 250 }
    },
    ...mapState(popIdsStore(COMPONENT_KEY.FILES_SCREEN), {
      filesPagePopIds: 'popIds',
      filesPagePopIdsError: 'error'
    }),
    ...mapState(popIdsStore(COMPONENT_KEY.LED_SCREEN), {
      ledPagePopIds: 'popIds',
      ledPagePopIdsError: 'error'
    }),
    ...mapState(popIdsStore(COMPONENT_KEY.VIDEOWALL_SCREEN), {
      videowallPagePopIds: 'popIds',
      videowallPagePopIdsError: 'error'
    }),
    ...mapState(selectionStore(COMPONENT_KEY.FILES_SCREEN), {
      filesPagePopIdSelectionData: 'popIds'
    }),
    ...mapState(selectionStore(COMPONENT_KEY.LED_SCREEN), {
      ledPagePopIdSelectionData: 'popIds'
    }),
    ...mapState(selectionStore(COMPONENT_KEY.VIDEOWALL_SCREEN), {
      videowallPagePopIdSelectionData: 'popIds'
    }),
    selectedPopIds () {
      if (this.isComponentUseInLedPage) {
        return this.ledPagePopIdSelectionData
      } else if (this.isComponentUseInVideowallPage) {
        return this.videowallPagePopIdSelectionData
      } else {
        return this.filesPagePopIdSelectionData
      }
    }
  },
  methods: {
    ...mapActions(popIdsStore(COMPONENT_KEY.FILES_SCREEN), {
      filesPageFetchPopIds: 'fetchPopIds',
      filesPageUpdatePopId: 'updatePopId',
      filesPageDeletePopId: 'deletePopId'
    }),
    ...mapActions(popIdsStore(COMPONENT_KEY.LED_SCREEN), {
      ledPageFetchPopIds: 'fetchPopIds',
      ledPageUpdatePopId: 'updatePopId',
      ledPageDeletePopId: 'deletePopId'
    }),
    ...mapActions(popIdsStore(COMPONENT_KEY.VIDEOWALL_SCREEN), {
      videowallPageFetchPopIds: 'fetchPopIds',
      videowallPageUpdatePopId: 'updatePopId',
      videowallPageDeletePopId: 'deletePopId'
    }),
    ...mapActions(selectionStore(COMPONENT_KEY.FILES_SCREEN), {
      filesPageUpdatePopIdSelectionStateData: 'updatePopIdsSelection'
    }),
    ...mapActions(selectionStore(COMPONENT_KEY.LED_SCREEN), {
      ledPageUpdatePopIdSelectionStateData: 'updatePopIdsSelection'
    }),
    ...mapActions(selectionStore(COMPONENT_KEY.VIDEOWALL_SCREEN), {
      videowallPageUpdatePopIdSelectionStateData: 'updatePopIdsSelection'
    }),
    emitEvent (action, data) {
      if (!_.isEmpty(action)) {
        _.delay(() => {
          this.$emit('popId-slider-change', { action, payload: { data, accessor: this.accessorComponent } })
        }, 10)
      }
    },
    setDefaultData () {
      this.isComponentUseInFilesPage = this.accessorComponent === CONST.COMPONENT_NAME_MEDIA_FILES
      this.isComponentUseInLedPage = this.accessorComponent === CONST.COMPONENT_NAME_LED_PAGE
      this.isComponentUseInVideowallPage = this.accessorComponent === CONST.COMPONENT_NAME_VIDEOWALL_PAGE
      this.isComponentUseInAlertPage = this.accessorComponent === CONST.COMPONENT_NAME_ALERT
      this.isComponentUseInSchedulePageAllPlayers = this.accessorComponent === CONST.COMPONENT_NAME_SCHEDULE_PAGE_ALL_PLAYERS
      this.isComponentUseInPlayersPage = this.accessorComponent === CONST.COMPONENT_NAME_PLAYERS_PAGE
      this.isComponentUseInMediaPicker = this.accessorComponent === CONST.COMPONENT_NAME_MEDIA_PICKER

      // Set default selected popIds from Filters Repository
      this.setSelectedPopIds(this.filterPopIdsForUI(this.$filtersRepository.findPopIds()))

      this.isEditPopIdActionEnabled = this.isComponentUseInFilesPage || this.isComponentUseInLedPage || this.isComponentUseInVideowallPage // Enable edit popId in files page, LED Page and Videowall page
      this.showPopIdsSlider = !this.isComponentUseInAlertPage // Hide popids in Alert page
      this.showDeleteAction = !this.isComponentUseInMediaPicker // Hide popid delete icon in media picker
      this.getPopIds()
    },
    setSelectedPopIds (popIds = []) {
      const selectedPopIds = popIds.filter(t => t.value !== CONST.ALL_TAG_VALUE)
      const selectedPopIdTagValues = selectedPopIds.map((t) => t.value)
      /**
       * Save selection to filtersRepository
       * Note: For now only Files Page will use filtersRepository and keep other pages to use localStorage
       */
      if (this.isComponentUseInFilesPage || this.isComponentUseInAlertPage || this.isComponentUseInLedPage || this.isComponentUseInVideowallPage) { // For files, alert and led page actions
        this.handleStateSelectionUpdates(selectedPopIds)
        this.$filtersRepository.savePopIds(selectedPopIdTagValues)
      } else {
        this.saveSelectedTagsToLocalStorage(selectedPopIdTagValues)
      }
    },
    filterPopIdsForUI (popIdsData = []) {
      if (!_.isArray(popIdsData) || (_.isArray(popIdsData) && _.isEmpty(popIdsData))) return []

      let newPopIds = [{
        ...this.defaultAllTag
      }]

      for (const popId of popIdsData) {
        let popIdItem = {
          value: '',
          backgroundColor: ''
        }

        if (_.isString(popId)) {
          popIdItem.value = popId
        } else if (_.isPlainObject(popId)) {
          popIdItem = popId

          if (popId.name) {
            popIdItem.value = popId.name
          }
        }

        popIdItem.label = popIdItem.value

        // Add to list if not exist and value is not an ALL tag
        if (_.isEmpty(newPopIds.find(t => t.value === popIdItem.value)) && popIdItem.value !== CONST.ALL_TAG_VALUE) {
          newPopIds.push(popIdItem)
        }
      }

      // Sort popIds
      newPopIds = this.$utils.sortTags({ tags: newPopIds })

      return newPopIds
    },
    setPopIdsData (popIds = []) {
      if (this.isComponentUseInAlertPage) { // Hide popIds in Alert Page
        this.showPopIdsSlider = false
      } else {
        this.getPopIds()
      }
    },
    setElementDataHeightAttributeValue () {
      this.elementHeight = $('#popIdentifierSlider').outerHeight()
    },
    handleContentScrollY () {
      // Prevent from scrolling if not expanded
      if (!this.expanded) {
        $(this.$refs.popIdsSliderPresentation.ps.element).scrollTop(0)
      }
    },
    // Handle popId selection request from other component to directly select popIds without clicking the element
    handlePopIdSelectionRequest (params = {}) {
      if (params.popIds) {
        const selectedPopIds = this.filterPopIdsForUI(params.popIds)
        this.setSelectedPopIds(selectedPopIds)
      }
    },
    async getPopIds () {
      const getPopIdsRequest = async () => {
        const params = {}

        if (this.isComponentUseInLedPage || this.isComponentUseInVideowallPage) {
          params.contextFilter = 'led'
        }

        let fetchedPopIds = []
        let fetchError = null
        if (this.isComponentUseInLedPage) {
          await this.ledPageFetchPopIds()
          fetchedPopIds = this.ledPagePopIds
          fetchError = this.ledPagePopIdsError
        } else if (this.isComponentUseInVideowallPage) {
          await this.videowallPageFetchPopIds()
          fetchedPopIds = this.videowallPagePopIds
          fetchError = this.videowallPagePopIdsError
        } else {
          await this.filesPageFetchPopIds()
          fetchedPopIds = this.filesPagePopIds
          fetchError = this.filesPagePopIdsError
        }

        this.popIds = this.filterPopIdsForUI(fetchedPopIds)
        this.emitEvent(CONST.EMIT_EVENT_LIST_OF_POP_IDS_FROM_SLIDER, this.popIds)

        this.$nextTick(() => {
          this.validateExpandIconVisibility()
          this.$utils.updatePageComponentStyle({ name: this.accessorComponent })
          this.addTagClassnameToHideOnDragging()

          // Validate each selected popIds if still exist in the list.If there are changes then update filtersRepository and send an event to parent component to refetch data.
          const currentSelection = _.clone(this.$filtersRepository.findPopIds())
          const updatedSelection = _.clone(currentSelection).filter(popId => !_.isEmpty(this.popIds.find(i => i.name === popId)))
          if (!this.isComponentUseInMediaPicker && !_.isEmpty(currentSelection) && _.sortedUniq(currentSelection) !== _.sortedUniq(updatedSelection)) {
            this.$filtersRepository.savePopIds(updatedSelection)
            this.emitEvent(CONST.EMIT_EVENT_REFETCH_PARENT_COMPONENT_LIST)
          }
        })
        if (fetchError) {
          this.$apiError.handleAPIRequestError(fetchError, { originalRequest: () => { getPopIdsRequest() }, showDialogNotification: false })
        }
      }
      await getPopIdsRequest()
    },
    saveSelectedTagsToLocalStorage (selectedTags) {
      const selectedPopIdsFromSlider = this.$dataStore.getStore().selectedPopIdsFromSlider ? this.$dataStore.getStore().selectedPopIdsFromSlider : {}
      selectedPopIdsFromSlider[this.accessorComponent] = selectedTags
      this.$dataStore.setStore({ selectedPopIdsFromSlider })
    },
    removeSelectedTagsToLocalStorage (removeTag) {
      const selectedPopIdsFromSlider = this.$dataStore.getStore().selectedPopIdsFromSlider ? this.$dataStore.getStore().selectedPopIdsFromSlider : {}

      if (selectedPopIdsFromSlider[this.accessorComponent] && selectedPopIdsFromSlider[this.accessorComponent].indexOf(removeTag.prevVal) >= 0) {
        selectedPopIdsFromSlider[this.accessorComponent].splice(removeTag.prevVal, 1)
      }

      this.$dataStore.setStore({ selectedPopIdsFromSlider })
    },
    isPopIdSelected (popId = {}) {
      return _.isPlainObject(this.selectedPopIds.find(p => p.value === popId.value))
    },
    handleEditPopId (popId, popIdIndex) {
      this.editPopIds = [popId]
      this.editPopIdValue = popId.value

      // Focus edit tag input
      this.$nextTick(_ => {
        const targetInputEl = this.$refs[`editPopIdInput${popIdIndex}`]

        if (targetInputEl && targetInputEl.length > 0) {
          targetInputEl[0].focus()
          targetInputEl[0].select()
        }
      })
    },
    resetEditPopId () {
      this.editPopIds = []
      this.editPopIdValue = ''
    },
    handlePopIdSelection (event = {}, popId = {}) {
      let selectedPopIdsData = this.$utils.clone(this.selectedPopIds)

      // Multiple Selection
      if (this.$utils.isCtrlKeyPressed(event)) {
        if (this.isPopIdSelected(popId)) {
          selectedPopIdsData = selectedPopIdsData.filter(t => t.value !== popId.value)
        } else {
          selectedPopIdsData.push(popId)
        }

        this.previousKeyPressedInTagsSelection = 'ctrl'
      } else { // Single Selection
        if (this.isPopIdSelected(popId)) {
          selectedPopIdsData = []
        } else {
          selectedPopIdsData = [popId]
        }

        this.previousKeyPressedInTagsSelection = null
      }

      // Set new selection data and emit an event to parent component with the values
      this.setSelectedPopIds(selectedPopIdsData)
      this.emitEvent(CONST.EMIT_EVENT_NEW_SELECTED_POP_ID_FROM_SLIDER, this.selectedPopIds.map(t => t.value))
    },
    handlePopIdItemClick (event = {}, popId = {}, popIdIndex = 0) {
      // Prevent selection because tag is in edit state
      if (event.target && ($(event.target).hasClass('el-input__inner'))) return

      // ALL PoPIds is selected
      if (popId && popId.value === CONST.ALL_TAG_VALUE) {
        this.setSelectedPopIds([])
        this.emitEvent(CONST.EMIT_EVENT_ALL_SELECTED_POPID_FROM_SLIDER, [])

        return
      }

      // Edit popId
      if (this.isEditPopIdActionEnabled && (this.isPopIdSelected(popId) && !this.$utils.isCtrlKeyPressed(event))) {
        this.resetEditPopId()
        this.handleEditPopId(popId, popIdIndex)

        return
      }

      // Process tag selection
      this.handlePopIdSelection(event, popId)
    },
    updatePopIdInList (newPopIdValue = '', oldPopIdValue = '') {
      this.popIds = this.filterPopIdsForUI(this.popIds.map(item => {
        if (item.value === oldPopIdValue) {
          return { ...item, name: newPopIdValue, value: newPopIdValue }
        } else {
          return item
        }
      }))
    },
    updatePopIdInSelectionList (newPopIdValue = '', oldPopIdValue = '') {
      const currentSelection = this.filesPagePopIdSelectionData.map(item => {
        if (item.value === oldPopIdValue) {
          return { ...item, name: newPopIdValue, value: newPopIdValue, sortValue: newPopIdValue, label: newPopIdValue }
        } else {
          return item
        }
      })

      this.handleStateSelectionUpdates(currentSelection)
    },
    handleConfirmEditPopId (newPopIdValue = '', oldPopIdValue = '') {
      if (_.isEmpty(newPopIdValue.trim()) || _.isEqual(newPopIdValue, oldPopIdValue)) {
        this.resetEditPopId()
        return
      }

      // Update popId in listing
      this.updatePopIdInList(newPopIdValue, oldPopIdValue)
      this.updatePopIdInSelectionList(newPopIdValue, oldPopIdValue)

      // Emit an event to parent component
      this.emitEvent('UPDATED_POPID_ITEM', { newPopIdValue, oldPopIdValue })

      // Dispatch an action in vuex to cleanup selected tags that was saved in localStorage
      if (this.accessorComponent === this.accessorComponentName.playerPage) {
        this.$store.dispatch('cleanUpSelectedTagsFromLocalStorage', {
          data: [{ name: 'playerPage', currentTags: this.tags }]
        })
      }

      this.editPopIdRequest(newPopIdValue, oldPopIdValue)
    },
    async editPopIdRequest (newPopIdValue = '', oldPopIdValue = '') {
      const editPopIdRequest = async () => {
        if (this.isComponentUseInLedPage) {
          await this.ledPageUpdatePopId(oldPopIdValue, newPopIdValue)
        } else if (this.isComponentUseInVideowallPage) {
          await this.videowallPageUpdatePopId(oldPopIdValue, newPopIdValue)
        } else {
          await this.filesPageUpdatePopId(oldPopIdValue, newPopIdValue)
        }
        // Update filters repository and send an event to parent to refetch data
        const updatedSelection = this.$filtersRepository.findPopIds().map((popId) => {
          if (popId === oldPopIdValue) {
            popId = newPopIdValue
          }
          return popId
        })

        this.$filtersRepository.savePopIds(updatedSelection)
        this.emitEvent(CONST.EMIT_EVENT_REFETCH_PARENT_COMPONENT_LIST)
        this.resetEditPopId()
        if (this.filesPagePopIdsError) {
          this.$apiError.handleAPIRequestError(this.filesPagePopIdsError, {
            originalRequest: () => { editPopIdRequest() },
            showDialogNotification: true,
            dialogEventOnClose: () => {
              // Revert changes in listing, oldValue as new value
              this.updatePopIdInList(oldPopIdValue, newPopIdValue)
              this.updatePopIdInSelectionList(oldPopIdValue, newPopIdValue)
            }
          })
        }
        this.resetEditPopId()
      }
      await editPopIdRequest()
    },
    handlePopIdHover ($event, type) {
      const targetEl = $($($event.target).parent())
      const textEl = $($($event.target).parent()).find('.text')
      let showTooltip = textEl.length && (textEl[0].offsetWidth < textEl[0].scrollWidth)

      if (type === 'mouseover' && showTooltip) {
        showTooltip = true
      } else {
        showTooltip = false
      }

      this.$utils.handleCustomTooltip({ targetEl, showTooltip, fullText: textEl.text() })
    },
    confirmDeletePopId (event, popId, indx) {
      // Send global event to show custom dialog
      EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
        type: 'warning',
        title: this.$t('confirm.deletePopId'),
        description: this.$t('popId.deletePopIdConfirmation'),
        popId: {
          name: popId.value
        },
        confirmButtonText: this.$t('buttons.deletePopId'),
        confirmButtonIcon: 'flowbite:trash-bin-solid',
        callbacks: {
          eventOnClose: () => {},
          eventOKButtonClick: () => {
            this.handleDeletePopId(event, popId, indx)
          }
        }
      })
    },
    async handleDeletePopId (event, popId, indx) {
      let popIds = this.$utils.clone(this.popIds)
      const popIdVal = popIds[indx]
      popIds.splice(indx, 1)

      if (popIds.find(p => p.value === CONST.ALL_TAG_VALUE)) {
        popIds = []
      }

      this.removeSelectedTagsToLocalStorage({ prevVal: popIdVal.value })
      this.popIds = popIds

      const deletePopIdRequest = async () => {
        this.$utils.mainLoader(true)

        if (this.isComponentUseInLedPage) {
          await this.ledPageDeletePopId(popId)
        } else if (this.isComponentUseInVideowallPage) {
          await this.videowallPageDeletePopId(popId)
        } else {
          await this.filesPageDeletePopId(popId)
        }

        if (this.filesPagePopIdsError) {
          this.$apiError.handleAPIRequestError(this.filesPagePopIdsError, { originalRequest: () => { deletePopIdRequest() }, showDialogNotification: true })
        }

        this.$nextTick(_ => {
          this.getPopIds()
        })
        this.setSelectedPopIds([])
        this.emitEvent(CONST.EMIT_EVENT_DELETED_POPID_FROM_SLIDER, this.popIds)

        // Clear selection to keep selected ALL popIds
        if ([this.accessorComponentName.mediaFiles, this.accessorComponentName.playerPage, this.accessorComponentName.ledPage].includes(this.accessorComponent)) {
          this.handleStateSelectionUpdates([])
        }
        this.$utils.mainLoader(true)
      }
      await deletePopIdRequest()
    },
    handleStateSelectionUpdates (selection) {
      if (this.isComponentUseInLedPage) {
        this.ledPageUpdatePopIdSelectionStateData(selection)
      } else if (this.isComponentUseInVideowallPage) {
        this.videowallPageUpdatePopIdSelectionStateData(selection)
      } else {
        this.filesPageUpdatePopIdSelectionStateData(selection)
      }
    },
    onEnter (event) {
      if (event.target.id === 'popid-slider-input') {
        event.target.blur()
      }
    },
    /**
     * Sets selectedDropzoneId and adds ui-droppable-hover class to element
     */
    setSelectedDropzoneId (dropzoneId) {
      if (!dropzoneId) {
        return
      }

      const dropzone = document.getElementById(dropzoneId)
      if (dropzone) {
        this.selectedDropzoneId = dropzoneId
        dropzone.classList.add('ui-droppable-hover')
      }
    },
    /**
     * Clears selectedDropzoneId and remove ui-droppable-hover class from element
     */
    removeSelectedDropzoneId () {
      if (!this.selectedDropzoneId) {
        return
      }

      const dropzone = document.getElementById(this.selectedDropzoneId)
      if (dropzone) {
        dropzone.classList.remove('ui-droppable-hover')
      }

      this.selectedDropzoneId = null
    },
    /**
     * Handle on drag move event for setting up selectedDropzoneId
     * from event.to
     */
    handleDraggableMove (event) {
      // Disabled dragging `All` tag
      if (
        event.dragged?.classList?.contains(CONST.ALL_TAG_VALUE) ||
        event.dragged?.className?.includes(CONST.ALL_TAG_VALUE) ||
        event.draggedContext?.element?.value === CONST.ALL_TAG_VALUE
      ) {
        return false
      }

      if (event.to.id === this.selectedDropzoneId) {
        return true
      }

      this.removeSelectedDropzoneId()
      this.setSelectedDropzoneId(event.to.id)

      return true
    },
    /**
     * Handle on drag move end event for restoring selectedDropzoneId
     */
    handleDraggableEnd () {
      this.removeSelectedDropzoneId()
    },

    refreshPopIdList () {
      this.setPopIdsData(this.popIds)
    }
  },
  mounted () {
    this.setDefaultData()
  },
  expose: ['refreshPopIdList']
}
